import { AxiosError } from 'axios';
import api from './utils/axios';

const PREFIX = 'agentos/analytics-dashboard';

export interface AnalyticsDashboardAccess {
  program_id: string;
  week: string;
  url: string;
  path: string;
  expires_at: null;
}

interface AnalyticsDashboardErrorBody {
  detail?: string;
  code?: string;
  programs?: string[];
}

const getAccessOnce = async (program?: string) => {
  const response = await api.get<AnalyticsDashboardAccess>(
    `${PREFIX}/access/`,
    {
      params: program ? { program } : undefined,
      suppressErrorToast: true,
    }
  );
  return response.data;
};

export const AnalyticsDashboardService = {
  /**
   * Where the tenant's published dashboard lives. A tenant with several
   * dashboards answers 400 `program_required`; we open the first one.
   */
  getAccess: async () => {
    try {
      return await getAccessOnce();
    } catch (error) {
      const data = (error as AxiosError<AnalyticsDashboardErrorBody>).response
        ?.data;
      const firstProgram = data?.programs?.[0];
      if (data?.code === 'program_required' && firstProgram) {
        return getAccessOnce(firstProgram);
      }
      throw error;
    }
  },
};
